export const COLORS = {
    // Backgrounds
    LIGHT_BG: '#F5F5F5',
    SUCCESS_LIGHT_BG: '#E6F7DD',
    LIGHT_GREY_BG: '#F7F7F7',
    LIGHT_BLUE_BG_2: '#E2EFFF',
    LIGHT_YELLOW_BG: '#FEF9EC',

    LIGHT_RED_BG: '#FFEEEE',
    LIGHT_BLUE_BG: '#F3F8FF',
    DARK_GREY_BG: '#EBEBEB',
    GREEN_BG: '#49A71B',
    LIGHT_PINK_BG: '#E1FFE1',
    PRIMARY_PURPLE: '#6021b3',
    PURPLE_TINT_50: '#F2E8FF',
    CYAN_TINT_100: '#E9FFFF',
    PURPLE_TINT_100: '#F2D5FF',
    BLUE_TINT_100: '#DCDEFF',
    PINK_TINT_200: '#FDEBFF',

    // Text
    BLACK: '#000000',
    GREY: '#B4B4B4',
    LIGHT_GREY: '#9D9D9D',
    DARK_GREY: '#4D4D4D',
    SUCCESS: '#49A71B',
    RED: '#DF666A',
    LIGHT_BLUE: '#2F8FFF',
    BLUE: '#004CA2',
    SECONDARY_YELLOW: '#B58802',
    BLUE_TINT_800: '#0013F6',
    GREEN_TINT_900: '#054D49',
    PURPLE_TINT_600: '#B000FB',
    PURPLE_TINT_900: '#871494',

    // Icons
    WHITE: '#FFFFFF',
};
